import { REDIRECT_BRIDGE_PATH } from './config/authConfig';

// Servers return index.html for every route, including the MSAL redirect bridge (msalConfig.auth.redirectUri).
// On that path load only the bridge, never the app: MsalProvider must not process the sign-in response there.
if (window.location.pathname === REDIRECT_BRIDGE_PATH) {
  void import('./redirectBridge');
} else {
  void import('./main');
}
